import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import {UserAutocompleteModule} from '../../../core/user-autocomplete/user-autocomplete.module';
import {ReasonCodeSelectionModalComponent} from './reason-code-selection-modal.component';
import {ReasonCodesModule} from './reason-codes/reason-codes.module';

@NgModule({
  imports: ReasonCodeSelectionModalModule.IMPORTS,
  declarations: ReasonCodeSelectionModalModule.DECLARATIONS,
  exports: ReasonCodeSelectionModalModule.DECLARATIONS
})
export class ReasonCodeSelectionModalModule {
  public static readonly IMPORTS = [
    ReasonCodesModule,
    CommonModule,
    MatButtonModule,
    UserAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatTooltipModule
  ];

  public static readonly DECLARATIONS = [ReasonCodeSelectionModalComponent];
}
